import React from "react";
import {
  Content,
  PageHeadingArea,
  BackArrow,
  PageTitle,
  PageHeadingAreaSpacer,
} from "@backslashbuild/pp-ui";
import { useParams, useHistory } from "react-router-dom";
import CSVImportEditor from "../modules/schedules-core/CSVImportEditor";

function ScheduleCoreCSVImport() {
  const { id } = useParams();
  const history = useHistory();
  return (
    <Content>
      <CSVImportEditor id={id} />
    </Content>
  );
}

export default ScheduleCoreCSVImport;
